import dayjs from 'dayjs'
import { Cookies } from 'react-cookie'

export const cookieManager = new Cookies()

export const getCookieClient = (key: string): string | null => {
  const token = cookieManager.get(key)
  if (
    !['boolean', 'string'].includes(typeof token) ||
    token === 'null' ||
    token === 'undefined'
  ) {
    return null
  }
  return token
}

export const setCookieClient = (key: string, value: string) => {
  const now = dayjs()
  const date = now.add(3, 'y')

  cookieManager.set(key, value, {
    expires: date.toDate(),
    path: '/',
  })
}
